import { Component, OnInit, ViewChild, AfterViewInit, Input, EventEmitter, Output } from '@angular/core';
import { AxChartComponent } from 'src/app/shared/components';
import { SummaryService } from '../../summary/summary.service';
import { FactorService } from '../factor.service';
import { NGXLogger } from 'ngx-logger';
import { AppFormatService } from 'src/app/shared/services';

@Component({
  selector: 'app-factor-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent implements AfterViewInit {
  @ViewChild(AxChartComponent) chart!: AxChartComponent;

  @Output() onClick = new EventEmitter();
  @Output() onLoad = new EventEmitter();

  constructor(
    public summary: SummaryService,
    private factor: FactorService,
    private logger: NGXLogger,
    private appFormat: AppFormatService
  ) {
  }

  ngAfterViewInit() {
    this.chart.series = [
      {
        type: 'bar',
        argumentField: 'currency',
        valueField: 'p',
        name: 'Portfolio'
      },
      {
        type: 'bar',
        argumentField: 'currency',
        valueField: 'b',
        name: 'Benchmark'
      },
      {
        type: 'bar',
        argumentField: 'currency',
        valueField: 'd',
        name: 'Active'
      }
    ];

    this.chart.argumentAxis = {
      argumentType: 'string',
      inverted: true
    };

    this.chart.rotated = true;
    this.chart.customizeTooltipFunc = (arg) => {
      return {
        text: arg.argument + '(' + arg.seriesName + '): ' + this.appFormat.GuiNumber(arg.value)
      }
    };

    //this.retrieve();
  }

  pointClickedHandler(e: any) {
    this.onClick.emit(e);
    //this.summary.analysisDate = new Date(point.argument);
    //this.summary.seriesName = point.series.name;
    //this.router.navigate(['/gfpa-detail', '' + this.summary.reportId, this.summary.analysisDate.toISOString(), point.series.name]);
  }

  public retrieve(category: string) {
    //this.dataSource = this.customStore;
    this.logger.debug("GFPA Factor retrieveCurrency started");
    this.chart.showLoadingIndicator();
    this.onLoad.emit();
    this.factor.retrieveCurrency(category).subscribe(
      data => {
        let jsonObj = JSON.parse(data);
        this.chart.dataSource = jsonObj;
        this.logger.debug("GFPA Factor retrieveCurrency finished");
      })
      .add(() => {
        this.chart.hideLoadingIndicator();
      });
  }
}
